import { get, post } from '@common/utils/dataProxy';
import URL from '@pages/index/common/URL';

// dataProxy unwraps code===0 to data, handles 401, and toasts errors by default.

const NO_TS = { withoutTimestamp: true };

// Position detail (relatedPositions, content sections, etc.)
export const getRecruitPositionDetail = (positionId) =>
  get(URL.GET_RECRUIT_POSITION_DETAIL, { positionId }, true, NO_TS).then(
    (d) => d || {}
  );

// Position types (drive the filter tabs on the top page)
export const getRecruitPositionTypes = () =>
  get(URL.GET_RECRUIT_POSITION_TYPES, {}, true, NO_TS).then((d) => d || []);

// Paginated position list (params: current/pageSize/positionTypeId)
export const getRecruitPositions = (params) =>
  get(URL.GET_RECRUIT_POSITIONS, params, true, NO_TS).then((d) => d || {});

// Submit application (multipart form-data). showErrorMsg=false: caller shows its own dialog.
export const submitRecruitApplication = (formData) =>
  post(URL.SUBMIT_RECRUIT, formData, false, NO_TS);
